import React from "react";
import clsx from "clsx";
// import { makeStyles } from "@mui/styles";
import { useCallback } from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import containerTheme from "./theme/containerTheme.js";
import { useEffect, useState, useLayoutEffect, useRef } from "react";
import LoadingSpinner from "./components/LoadingSpinner";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import "./Spinner.css";
import * as XLSX from "xlsx";
import { isWasteMetric, buildWastePreflightSummary } from "./utils/wasteUploadUtils";
import _ from "lodash";
import Dropzone from "react-dropzone";
import CloudUploadTwoToneIcon from "@mui/icons-material/CloudUploadTwoTone";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Row, Col, Card, Table, Alert } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import DeleteConfirmation from "./components/DeleteConfirmation";
import Button from "@mui/material/Button";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Box from "@mui/material/Box";
import { Modal, ModalBody, ModalHeader, ModalFooter, ModalTitle } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { FaSearch } from "react-icons/fa";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net";
import DataTables from "datatables.net";
import $ from "jquery";
import { classNames } from "primereact/utils";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Tag } from "primereact/tag";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import { Paginator } from "primereact/paginator";
import "./table.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
import { formatRequirementFieldName, filterExcelHeaders } from "./configuration.js";
import ReviewGateModal from "./components/ReviewGateModal.js";
import MappingGateModal from "./components/MappingGateModal.js";
import ElectricityAnomalyStatus from "./components/anomaly/ElectricityAnomalyStatus";
import { runAnomalyDetectionFromExcelRows, formatAnomalySummary } from "./services/excelAnomalyDetection";
import { excelSerialToIsoDateString, isDateColumnHeader, validateUploadDateRows, validateUploadDataFrequency, buildDateValidationSummary, normalizeUploadDatesInRows } from "./utils/uploadDateUtils";
import { getCountryForSiteLocation } from "./utils/countryDateFormat";
import { analyzePlatformPeriodConflicts, confirmPlatformPeriodOverwrite, extractPlatformPeriodsFromHistory, extractUploadPeriods, fetchMetricReportHistory, getMetricDateValidationPolicy } from "./utils/periodOverlapUploadUtils";
import { disambiguateSourceLabel } from "./utils/sourceLabelDisplay";
import { normalizePayloadRow, splitConnectorItem } from "./utils/connectorConfigUtils";

/**
 * All Configurations Excel upload date handling.
 * true  → legacy: Excel serial → ISO yyyy-MM-dd, typed text dates unchanged; validation still runs.
 * false → strict path: column inference, ISO normalisation, duplicate-month / range checks.
 * Flip this flag to revert without losing the strict implementation.
 */
const USE_LEGACY_DATE_UPLOAD = true;

const dropdownItemTemplate = (option) => (
  <span className="form-dropdown-option-text" title={option?.label}>
    {option?.label}
  </span>
);

const modal = {
  widthCustom: {
    width: 800,
  },
};

/**
 * Checks if the given connector type is PDF (case-insensitive).
 * @param {string | null | undefined} connectorType - The connector type to check
 * @returns {boolean} True if the connector type is PDF
 */
function isPdfConnector(connectorType) {
  return (connectorType || "").toUpperCase() === "PDF";
}

/** Returns true when every mandatory requirement field has a source column other than "None". */
function mandatoryExcelMappingsComplete(excelfields, excelMappingByDest) {
  if (!excelfields || typeof excelfields !== "object") return false;
  const keys = Object.keys(excelfields);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (excelfields[key] !== true) continue;
    const v = excelMappingByDest[key];
    if (v === undefined || v === null || String(v).trim() === "" || v === "None") return false;
  }
  return true;
}

/**
 * Checks if the given connector type is Excel (case-insensitive).
 * @param {string | null | undefined} connectorType - The connector type to check
 * @returns {boolean} True if the connector type is Excel
 */
function isExcelConnector(connectorType) {
  return (connectorType || "").toUpperCase() === "EXCEL";
}

function isApiConnector(connectorType) {
  return (connectorType || "").toUpperCase() === "API";
}

/**
 * Returns the appropriate icon element for a given file format/connector type.
 * @param {string | null | undefined} fileFormat - The file format to get icon for
 * @param {number} width - The width of the icon (default: 40)
 * @returns {JSX.Element} The icon element
 */
function getConnectorIcon(fileFormat, width = 40) {
  const format = (fileFormat || "").toUpperCase();
  const style = { width: `${width}px` };

  switch (format) {
    case "EXCEL":
      return <img src="assets/img/2.png" style={style} alt="Excel" />;
    case "API":
      return <img src="assets/img/api.png" style={style} alt="API" />;
    case "AZURE TABLE STORAGE":
      return <img src="assets/img/azure.png" style={style} alt="Azure" />;
    case "PDF":
      return <img src="assets/img/pdf.png" style={style} alt="PDF" />;
    default:
      return <span>{fileFormat}</span>;
  }
}

export default function Home() {
  const username = localStorage.getItem("userName");
  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  // const classes = useStyles();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [sloading, setSloading] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const steps = [
    {
      label: "Select data type",
      description: ``,
    },
    {
      label: "Choose data connector",
      description: "",
    },
    {
      label: "Create connection",
      description: "",
    },
    {
      label: "Map fields",
      description: "",
    },
    {
      label: "Review and finish",
      description: "",
    },
  ];

  const handleNext = () => {
    // For PDF: skip step 3 (field mapping) - go from step 2 directly to step 4
    if (activeStep === 2 && isPdfConnector(selectedExcel)) {
      setActiveStep(4);
      setMatrics(matrics);
      setMyModule(mymodule);
      return;
    }

    if (activeStep === 3 && !isPdfConnector(selectedExcel)) {
      if (!mandatoryExcelMappingsComplete(excelfields, excelMappingByDest)) {
        Swal.fire({
          icon: "warning",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Required mappings missing</h4>
            <p style="font-size: 16px;">Please map all mandatory fields (marked with *) to a column from your data source before continuing.</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return;
      }
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setMatrics(matrics);
    setMyModule(mymodule);

    if (activeStep === 1) {
      fetchFields();
    }

    if (activeStep === 3) {
      const destinationInputs = document.getElementsByName("destination[]");
      const destination = Array.from(destinationInputs).map((input) => input.value);
      setRightHeader(destination);

      const excelHeaderInputs = document.getElementsByName("excelHeaders[]");
      const excelHeaders = Array.from(excelHeaderInputs).map((input) => input.value);
      setLeftHeader(excelHeaders);
    }
  };

  const handleBackConfig = () => {
    setShowTable(false);
  };

  const handleBack = () => {
    // For PDF: skip step 3 (field mapping) - go from step 4 back to step 2
    if (activeStep === 4 && isPdfConnector(selectedExcel)) {
      setActiveStep(2);
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  async function fetchFields() {
    try {
      var myH = new Headers();
      myH.append("username", username);
      myH.append("modulename", mymodule);
      myH.append("pattern", selectedExcel);
      myH.append("ESGMetric", matrics);
      var requestO = {
        method: "GET",
        headers: myH,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-fields`, requestO);
      const data = await response.json();
      setFields(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  let handleSubmit = async (e) => {
    e.preventDefault();
    const isPdf = isPdfConnector(selectedExcel);

    // For PDF: skip field mapping processing - LLM handles extraction automatically
    let outputObject = {};
    if (!isPdf) {
      const newArray = leftheader.map((item, i) => item + ":" + rightheader[i]);

      outputObject = newArray.reduce((result, item) => {
        const { key, value } = splitConnectorItem(item);
        result[key] = value;
        return result;
      }, {});
    }

    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}UpdateConnectorConfig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          siteLocationId: site,
          fileFormat: selectedExcel,
          module: mymodule,
          esgmetric: matrics,
          fieldMapping: isPdf ? null : outputObject, // PDF doesn't need field mapping
        }),
      });
      if (res.status === 200) {
        setEditIsOpen(false);
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.title}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else {
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connector Config updated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
      } else {
        setEditIsOpen(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">Error In Update Connector Config</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const excelH = (value, destKey) => {
    setExcelMappingByDest((prev) => ({ ...prev, [destKey]: value }));
  };

  /**
   * Returns true when `header` (an Excel column name) is already mapped to a
   * requirement other than `currentKey`. Used to disable duplicate selections in
   * the field-mapping dropdowns so a single source column cannot be mapped to
   * more than one destination requirement. "None" is always selectable.
   */
  const isHeaderMappedElsewhere = (header, currentKey) => {
    if (!header || header === "None") return false;
    const entries = Object.entries(excelMappingByDest || {});
    for (let i = 0; i < entries.length; i += 1) {
      const [k, v] = entries[i];
      if (k !== currentKey && v === header) return true;
    }
    return false;
  };

  const saveData = async () => {
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}update-businessunit`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.title}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else {
          fetchConnectorConfig();
          Swal.fire({
            icon: "success",
            title: "Business Unit Updated successfully",
          });
        }
        setEditIsOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error In Update Business Unit",
        });
        setEditIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [config, setConfig] = useState("");
  const [activeconfig, setActiveConfig] = useState("");
  const [deactiveconfig, setDeactiveConfig] = useState("");
  const [importfile, setImportFile] = React.useState("");
  const [headerfields, setHeaderFields] = React.useState([]);
  const [headerSourceLabels, setHeaderSourceLabels] = React.useState({});
  const [message, setMessage] = React.useState(false);
  const [editIsOpen, setEditIsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewRows, setReviewRows] = useState([]);
  const [showMappingModal, setShowMappingModal] = useState(false);
  const [mappingItems, setMappingItems] = useState([]);
  // Metric of the run whose rows are in the review modal; drives the modal variant (PGS vs waste).
  const [reviewMetric, setReviewMetric] = useState("");

  // Deep link from the waste dashboard ("Review now"): /allconfiguration?review=waste opens the queue.
  useEffect(() => {
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    if (params.get("review") !== "waste") return;
    const user = localStorage.getItem("userName");
    fetch(`${process.env.REACT_APP_BASE_API_URL}GetWasteReviewQueue`, { headers: { username: user, site: "" } })
      .then((r) => r.json())
      .then((data) => {
        const queue = data && Array.isArray(data.data) ? data.data : [];
        if (queue.length === 0) return;
        setReviewMetric("Waste Generated in Operations");
        setReviewRows(queue);
        setShowReviewModal(true);
      })
      .catch((e) => console.log("Waste review queue failed:", e));
  }, []);
  const [mappingScope, setMappingScope] = useState({ siteLocation: "", esgMetric: "" });
  const pendingRunRef = React.useRef(null);
  const [site, setSite] = React.useState("");
  const [file, setFile] = React.useState("");
  const [esg, setESG] = React.useState("");
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [deletename, setDeleteName] = useState(null);
  const [modules, setModules] = React.useState(false);
  const [mymodule, setMyModule] = useState("");
  const [module, setModule] = useState("");
  const [excelfields, setFields] = React.useState(false);
  const [pattern, setPattern] = useState("");
  const [sitelocation, setSiteLocation] = useState("");
  const [sitelocation1, setSiteLocation1] = useState("");
  const [leftheader, setLeftHeader] = useState("");
  const [rightheader, setRightHeader] = useState("");
  const [smartMappingSuggestions, setSmartMappingSuggestions] = useState(null);
  /** Destination field key → selected Excel header (or "None"). Keeps Map fields step in sync for validation. */
  const [excelMappingByDest, setExcelMappingByDest] = useState({});
  const [matrics, setMatrics] = useState("");
  const [mymatrics, setMyMatrics] = useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedExcel, setSelectedExcel] = useState("");
  const [showTable, setShowTable] = React.useState(false);
  const editSessionRef = useRef(0);
  const isEditModalOpenRef = useRef(false);
  const [searchsite, setSearchSite] = useState("");
  const [searchesg, setSearchESG] = useState("");
  const [activeCounter, setActiveCounter] = useState();
  const [inactiveCounter, setInActiveCounter] = useState();
  const [active, setActive] = useState("");
  const [inactive, setInactive] = useState("");
  const [inact, setInact] = useState("");
  const [act, setAct] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    siteLocationId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    esgMetric: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fileFormat: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportFrequency: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updatedAt: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [filters1, setFilters1] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    siteLocationId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    esgMetric: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fileFormat: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportFrequency: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updatedAt: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");
  const renderHeader2 = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <div class="col-md-6 pd-0">
          <button id="active" className={act} onClick={() => toggleTable("active")}>
            <span className="record-count">{activeCounter}</span>
            <span className="record-title">Active</span>
          </button>
          <button id="inactive" className={inact} onClick={() => toggleTable("inactive")}>
            <span className="record-count">{inactiveCounter}</span> <span className="record-title">Inactive </span>{" "}
          </button>
        </div>
        <div class="col-md-6 pd-0 mt-top10 txt-end">
          <span className="p-input-icon-left">
            <img src="assets/img/search.png" className="search-i" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
          </span>
        </div>
      </div>
    );
  };

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-end">
        <div class="col-md-6 pd-0">
          <button id="active" className={act} onClick={() => toggleTable("active")}>
            <span className="record-count">{activeCounter}</span>
            <span className="record-title">Active</span>
          </button>
          <button id="inactive" className={inact} onClick={() => toggleTable("inactive")}>
            <span className="record-count">{inactiveCounter}</span> <span className="record-title">Inactive </span>{" "}
          </button>
        </div>
        <div class="col-md-6 pd-0 mt-top10 txt-end">
          <span className="p-input-icon-left">
            <img src="assets/img/search.png" className="search-i" />
            <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Search" />
          </span>
        </div>
      </div>
    );
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters = { ...filters1 };

    _filters["global"].value = value;

    setFilters1(_filters);
    setGlobalFilterValue1(value);
  };

  const header = renderHeader();
  const header1 = renderHeader1();

  const resetEditDraftState = () => {
    setImportFile("");
    setHeaderFields([]);
    setLeftHeader("");
    setRightHeader("");
    setExcelMappingByDest({});
  };

  const showEditModal = (module, esg, site, file) => {
    // Always start edit modal with a clean draft state.
    resetEditDraftState();
    editSessionRef.current += 1;
    isEditModalOpenRef.current = true;
    localStorage.setItem("type", file);
    setActiveStep(0);
    setModule(esg);
    setMyModule(esg);
    setESG(esg);
    setMatrics(esg);
    setSite(site);
    setSiteLocation1(site);
    setFile(file);
    setPattern(file);
    setSelectedExcel(file);
    setEditIsOpen(true);
  };

  const hideEditModal = () => {
    // Cancel/close should discard any partially uploaded draft file.
    resetEditDraftState();
    editSessionRef.current += 1; // Invalidate in-flight async upload callbacks.
    isEditModalOpenRef.current = false;
    setActiveStep(0);
    setEditIsOpen(false);
  };

  async function fetchSiteLocation() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-sitelocation`, requestOptions);
      const data = await response.json();
      setSiteLocation(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESGMatrics(value) {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      myHeaderss.append("param", value);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}ESG`, requestOptionss);
      const data = await response.json();
      setMyMatrics(data);
    } catch (error) {
      console.error(error);
    }
  }

  const showDeleteModal = (site, file, esg) => {
    setSite(site);
    setFile(file);
    setESG(esg);
    setDeleteName(site);
    setDeleteMessage("Are you sure you want to deactivate the connection for " + esg + " - " + site + "?");
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const searchData = async () => {
    const data = localStorage.getItem("allconfig");
    if (!data) return;

    const parsedData = JSON.parse(data);

    if (searchsite === "" && searchesg === "") {
      setActiveConfig(parsedData);
      return;
    }

    const filteredData = parsedData.filter((item) => {
      const matchesSite = searchsite === "" || item.siteLocationId === searchsite;
      const matchesEsg = searchesg === "" || item.esgMetric === searchesg;
      return matchesSite && matchesEsg;
    });

    setActiveConfig(filteredData);
  };

  const reactive = async (name, esg, file) => {
    setLoading(true);
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}reactive-configuration`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
          file: file,
          esg: esg,
          name: name,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
            text: responseJson.data,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else if (responseJson.status == 400) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.title}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else {
          setLoading(false);
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Configuration reactivated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
        fetchConnectorConfig();
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">Error in reactivate configuration</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const submitDelete = async () => {
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}delete-connector-cofig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          site: site,
          file: file,
          esg: esg,
          username: username,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        fetchConnectorConfig();
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.title}</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        } else {
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connector Config deactivated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
        setDisplayConfirmationModal(false);
      } else {
        toast.error("Error In Deactivate Connector Config");
        setDisplayConfirmationModal(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  async function fetchConnectorConfig() {
    setSloading(true);
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-connector-config`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success === false || responseJson.status === 400) {
          setSloading(false);
          setConfig("");
        } else {
          setSloading(false);
          localStorage.setItem("allconfig", JSON.stringify(responseJson.data));
          setConfig(responseJson.data);
          setActiveConfig(responseJson.data.filter((item) => item.isActive === true));
          setDeactiveConfig(responseJson.data.filter((item) => item.isActive === false));
          setActiveCounter(responseJson.data.filter((item) => item.isActive === true).length);
          setInActiveCounter(responseJson.data.filter((item) => item.isActive === false).length);
        }
      } else {
        setSloading(false);
        setConfig("");
      }
      setIsLoading(false);
    } catch (error) {
      setSloading(false);
      setIsLoading(false);
      console.error(error);
    }
  }

  async function fetchModules() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-modules`);
      const data = await response.json();
      setModules(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchConnectorConfig();
    fetchModules();
    fetchSiteLocation();
  }, []);

  // Ensure each requirement row has a mapping value when on Map fields (default "None" until user selects).
  useEffect(() => {
    if (activeStep !== 3 || !excelfields || typeof excelfields !== "object") return;
    const keys = Object.keys(excelfields);
    setExcelMappingByDest((prev) => {
      const next = { ...prev };
      keys.forEach((k) => {
        if (next[k] === undefined) next[k] = "None";
      });
      Object.keys(next).forEach((k) => {
        if (!keys.includes(k)) delete next[k];
      });
      return next;
    });
  }, [activeStep, excelfields]);

  // Apply smart field mapping when entering step 3 (Map Fields)
  useEffect(() => {
    if (activeStep !== 3 || !smartMappingSuggestions || !excelfields || typeof excelfields !== "object" || Object.keys(excelfields).length === 0) {
      return;
    }
    const destinationKeys = Object.keys(excelfields);
    const patch = {};
    destinationKeys.forEach((destKey) => {
      if (smartMappingSuggestions[destKey]) {
        patch[destKey] = smartMappingSuggestions[destKey];
      }
    });
    if (Object.keys(patch).length > 0) {
      setExcelMappingByDest((prev) => ({ ...prev, ...patch }));
    }
    setSmartMappingSuggestions(null);
  }, [activeStep, excelfields, smartMappingSuggestions]);

  const onDrop = useCallback((acceptedFiles, site, type, esgmetric, reportFrequency) => {
    setSloading(true);
    const fileName = acceptedFiles[0].name;
    const fileExtension = fileName.split(".").pop().toLowerCase();
    if (fileExtension !== "xls" && fileExtension !== "xlsx") {
      setSloading(false);
      Swal.fire({
        icon: "error",
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Invalid File Format</h4>
               <p style="font-size: 16px;">The uploaded file "<strong>${fileName}</strong>" is not an Excel file. Please upload a valid Excel file (.xlsx or .xls).</p>`,
      });
      return;
    }
    setImportFile(fileName);
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = async (evt) => {
        // evt = on_file_select event
        const bstr = evt.target.result;
        // cellText:true forces cell.w (display text) generation for every cell.
        // We then read cells directly from the worksheet object to avoid all
        // sheet_to_json alignment edge-cases (row skipping, defval quirks, etc.).
        const wb = XLSX.read(bstr, { type: "binary", cellText: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        if (!ws || !ws["!ref"]) {
          setSloading(false);
          return;
        }
        const range = XLSX.utils.decode_range(ws["!ref"]);

        // Read headers from the first row.
        const headers = [];
        for (let C = range.s.c; C <= range.e.c; C++) {
          const addr = XLSX.utils.encode_cell({ r: range.s.r, c: C });
          const cell = ws[addr];
          headers.push(cell && cell.v !== undefined && cell.v !== null ? cell.v.toString().trim() : "");
        }
        setHeaderFields(headers.filter((h) => h !== ""));

        // isDateKey: detect date-like column headers.
        const isDateKey = isDateColumnHeader;

        // Read each data row directly from worksheet cells.
        // Priority: cell.w (display text from cellText:true) → manual serial format for
        // date columns → cell.v.toString() for other types → '' for empty cells.
        const rowData = [];
        for (let R = range.s.r + 1; R <= range.e.r; R++) {
          const rowObj = {};
          for (let C = range.s.c; C <= range.e.c; C++) {
            const header = headers[C - range.s.c];
            if (!header) continue;
            const addr = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = ws[addr];
            if (!cell || cell.v === undefined || cell.v === null) {
              rowObj[header] = "";
              continue;
            }
            // Prefer display text (cell.w) for all columns, including Excel date serials.
            // Serial→ISO here used the workbook locale (often US), so "1/3/2024" became
            // 2024-01-03 while "31/03/2024" stayed European text — backend then saved
            // DateTime.MinValue. Keep the displayed string and normalise with partner
            // context below before RunReport.
            if (cell.w && cell.w.trim() !== "") {
              const isNumericW = /^\d+(\.\d+)?$/.test(cell.w.trim());
              // Pure numeric display on a date column is still the serial — convert to ISO.
              if (isDateKey(header) && isNumericW && cell.t === "n" && typeof cell.v === "number" && cell.v >= 1) {
                rowObj[header] = excelSerialToIsoDateString(cell.v);
              } else {
                rowObj[header] = cell.w.trim();
              }
              continue;
            }
            if (cell.t === "n") {
              if (isDateKey(header)) {
                if (cell.v >= 1) {
                  rowObj[header] = excelSerialToIsoDateString(cell.v);
                } else {
                  rowObj[header] = cell.v.toString();
                }
              } else {
                rowObj[header] = cell.v.toString();
              }
              continue;
            }
            // String, boolean, error, etc.
            rowObj[header] = cell.v.toString();
          }
          rowData.push(rowObj);
        }
        const newdatas = [];
        // Filter out rows with incomplete or invalid data
        const filteredRowData = rowData.filter((row, index) => {
          // Count how many fields have actual values (not empty, null, undefined, or "N/A")
          const nonEmptyFields = Object.values(row).filter((value) => value !== null && value !== undefined && value !== "" && value !== "N/A").length;

          // Get total number of fields in the row
          const totalFields = Object.keys(row).length;

          // Check if row has at least 3 fields with values (adjust this threshold as needed)
          const hasMinimumFields = nonEmptyFields >= 3;

          // Check if row has at least 50% of fields filled
          const hasMinimumPercentage = nonEmptyFields >= Math.ceil(totalFields * 0.5);

          return hasMinimumFields && hasMinimumPercentage;
        });

        const filteredRowsWithNumbers = filteredRowData.map((row, index) => ({
          row,
          rowNumber: index + 2,
        }));

        const convertedData = filteredRowsWithNumbers.map(({ row, rowNumber }) => {
          const convertedRow = {};
          for (const key in row) {
            if (USE_LEGACY_DATE_UPLOAD && typeof row[key] === "number" && /date/i.test(key)) {
              convertedRow[key] = excelSerialToIsoDateString(row[key]);
            } else {
              convertedRow[key] = typeof row[key] === "number" ? row[key].toString() : row[key];
            }
          }
          convertedRow.__rowNumber = rowNumber;
          newdatas.push(convertedRow);
          return convertedRow;
        });

        const siteCountry = getCountryForSiteLocation(sitelocation, site);
        const dateNormalizationErrors = normalizeUploadDatesInRows(convertedData, { country: siteCountry });
        if (dateNormalizationErrors.length > 0) {
          setSloading(false);
          const errorHtml = dateNormalizationErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
          Swal.fire({
            icon: "error",
            html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
              <p style="font-size:16px; margin-bottom: 12px;">${buildDateValidationSummary(dateNormalizationErrors)}</p>
              <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            width: "650px",
          });
          return;
        }

        // Metric-specific date validation (see periodOverlapUploadUtils.getMetricDateValidationPolicy).
        const datePolicy = getMetricDateValidationPolicy(esgmetric);
        {
          const uploadedRowsForValidation = convertedData.map((row) => ({
            rowNumber: row.__rowNumber,
            data: row,
          }));

          if (datePolicy.mode !== "none") {
            if (datePolicy.frequencyCheck) {
              const { errors: frequencyErrors } = validateUploadDataFrequency(uploadedRowsForValidation, reportFrequency);
              if (frequencyErrors.length > 0) {
                setSloading(false);
                const errorHtml = frequencyErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
                    <p style="font-size:16px; margin-bottom: 12px;">${buildDateValidationSummary(frequencyErrors)}</p>
                    <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                  width: "650px",
                });
                return;
              }
            }

            const checkPeriodOverlap = datePolicy.mode === "period" || datePolicy.mode === "typedPeriod";
            const { errors: overlapErrors } = validateUploadDateRows(uploadedRowsForValidation, {
              checkPeriodOverlap,
              getTypeKey: datePolicy.mode === "typedPeriod" ? datePolicy.getTypeKey : null,
              typeLabel: datePolicy.typeLabel || null,
            });
            if (overlapErrors.length > 0) {
              setSloading(false);
              const errorHtml = overlapErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
              const summaryText = buildDateValidationSummary(overlapErrors);
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
                  <p style="font-size:16px; margin-bottom: 12px;">${summaryText}</p>
                  <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                width: "650px",
              });
              return;
            }
          }
        }

        const payloadRows = convertedData.map(({ __rowNumber, ...row }) => normalizePayloadRow(row));

        let replaceOverlappingPeriods = false;
        if (datePolicy.platformOverwrite) {
          try {
            const { raw } = await fetchMetricReportHistory(username, site, esgmetric);
            const platformPeriods = extractPlatformPeriodsFromHistory(raw, datePolicy);
            const uploadPeriods = extractUploadPeriods(
              convertedData.map((row) => ({ rowNumber: row.__rowNumber, data: row })),
              datePolicy,
            );
            const platformConflicts = analyzePlatformPeriodConflicts(uploadPeriods, platformPeriods, datePolicy);
            if (platformConflicts.hasConflicts) {
              setSloading(false);
              const confirmed = await confirmPlatformPeriodOverwrite({ ...platformConflicts, policy: datePolicy });
              if (!confirmed) {
                return;
              }
              replaceOverlappingPeriods = true;
              setSloading(true);
            }
          } catch (platformErr) {
            console.error("Platform period check failed:", platformErr);
          }
        }

        // Runs the report for the given rows. Defined as a function so it can be invoked
        // directly (no review needed) or deferred until pre-flight mappings are confirmed.
        const executeRunReport = (payloadRows, site, type, esgmetric, replaceOverlapping = false) => {
          fetch(`${process.env.REACT_APP_BASE_API_URL}RunReport`, {
            method: "POST",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              username: username,
              site: site,
              type: type,
              esgmetric: esgmetric,
              ...(replaceOverlapping ? { replaceoverlappingperiods: "true" } : {}),
            },
            body: JSON.stringify(payloadRows),
          })
            .then((response) => response.json())
            .then(async (data) => {
              let anomalySummaryHtml = "";
              // Soft validation failures sometimes come back as success:true with a string message
              // (e.g. "Site Location X is NULL or Not found.") — surface that clearly.
              if (typeof data.data === "string") {
                setSloading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">${data.data}</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
                return;
              }
              if (data.success !== false && data.data?.successfulRecords > 0) {
                try {
                  const summary = await runAnomalyDetectionFromExcelRows({
                    rows: payloadRows,
                    facility: site,
                    esgMetric: esgmetric,
                    fileName,
                  });
                  anomalySummaryHtml = formatAnomalySummary(summary, {
                    facility: site,
                    esgMetric: esgmetric,
                  });
                } catch (anomalyErr) {
                  console.error("Post-report anomaly detection:", anomalyErr);
                  anomalySummaryHtml = '<p style="font-size:14px;margin-top:10px;color:#856404;">Anomaly scan could not complete. Ensure EcoUtil (:8000) and ecoprismapi are running.</p>';
                }
              }

              if (data.success == false) {
                setSloading(false);
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">${data.data}</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                });
              } else {
                setSloading(false);
                // Human gate: rows that matched ambiguously come back as "successful"
                // with status "NeedsReview" + candidatesJson. Surface them for review
                // instead of the plain summary popup.
                const needsReview = (data.data && Array.isArray(data.data.successfulResults) ? data.data.successfulResults : []).filter((r) => r && (r.status || "").toLowerCase() === "needsreview");
                if (needsReview.length > 0) {
                  setReviewMetric(esgmetric);
                  setReviewRows(needsReview);
                  setShowReviewModal(true);
                  return;
                }
                if (data.data.totalRecords === data.data.successfulRecords) {
                  Swal.fire({
                    icon: "success",
                    iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
                    text: "Successfully rows added is " + data.data.successfulRecords,
                    html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Report run successfully</p><div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' + data.data.totalRecords + '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' + data.data.successfulRecords + "</div></div>" + anomalySummaryHtml,
                  });
                }
                if (data.data.totalRecords == data.data.failedRecords) {
                  const rowErrors = [];
                  if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                    data.data.failedResults.forEach((failedRecord, index) => {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                        failedRecord.errors.forEach((error) => {
                          rowErrors.push({ row: rowNum, error });
                        });
                      }
                    });
                  }
                  const errorHtml = rowErrors.length === 0 ? '<p style="font-size:14px;">No error details available.</p>' : rowErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
                  Swal.fire({
                    icon: "error",
                    html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                    <p style="font-size:16px; margin-bottom: 15px;">All records failed to process. Please check the following errors:</p>
                    <div style="max-height: 300px; overflow-y: auto; text-align: left;">
                      ${errorHtml}
                    </div>`,
                    iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                    width: "600px",
                  });
                }
                if (data.data.failedRecords >= 1 && data.data.totalRecords !== data.data.failedRecords) {
                  const partialRowErrors = [];
                  if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                    data.data.failedResults.forEach((failedRecord, index) => {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                        failedRecord.errors.forEach((error) => {
                          partialRowErrors.push({ row: rowNum, error });
                        });
                      }
                    });
                  }
                  let partialErrorDetailHtml = "";
                  if (partialRowErrors.length > 0) {
                    const partialErrorLines = partialRowErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 3px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
                    partialErrorDetailHtml = `<div style="max-height: 200px; overflow-y: auto; text-align: left; margin-top: 12px; border-top: 1px solid #e0e0e0; padding-top: 10px;"><p style="font-size:14px; font-weight: bold; margin-bottom: 6px;">Error details for failed rows:</p>${partialErrorLines}</div>`;
                  }
                  Swal.fire({
                    icon: "warning",
                    html:
                      '<h4 style="color: #f8bb86; font-size: 20px; font-weight: bold;">Warning</h4><p style="font-size:16px;">Report run with some errors</p><div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' +
                      data.data.totalRecords +
                      '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' +
                      data.data.successfulRecords +
                      '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left35">Invalid Records: </div><div class="col-md-3 wd-20">' +
                      data.data.failedRecords +
                      "</div></div>" +
                      partialErrorDetailHtml +
                      anomalySummaryHtml,
                    width: "600px",
                  });
                }
              }
            })
            .catch((error) => {
              setSloading(false);
              console.log(error);
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">Error In Run Report</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
            });
        };

        // Pre-flight: resolve activity mappings BEFORE running. The backend returns only the
        // products that are in question (ambiguous/weak and not already saved); known + strong
        // are resolved silently. If any need review, prompt now and defer the run until saved.
        let preflightData = null;
        try {
          const pfResp = await fetch(`${process.env.REACT_APP_BASE_API_URL}PreflightMappings`, {
            method: "POST",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              username: username,
              site: site,
              type: type,
              esgmetric: esgmetric,
            },
            body: JSON.stringify(payloadRows),
          });
          const pf = await pfResp.json();
          preflightData = pf && pf.data;
        } catch (e) {
          // Pre-flight is best-effort; if it fails, fall through and run (post-run review still applies).
          console.log("Preflight failed:", e);
        }

        if (isWasteMetric(esgmetric)) {
          // Waste preflight is a dry run (what calculates / is held for review / fails). Review itself happens
          // after the run through ReviewGateModal and is remembered per company by the backend, so here we
          // only ask for confirmation when something would be held or rejected.
          const summary = buildWastePreflightSummary(preflightData);
          if (preflightData && summary.needsAttention) {
            setSloading(false);
            const proceed = await Swal.fire({
              icon: "info",
              title: "Waste upload check",
              html: summary.html,
              showCancelButton: true,
              confirmButtonText: "Run anyway",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#407775",
            });
            if (!proceed.isConfirmed) {
              setLoading(false);
              return;
            }
            setSloading(true);
          }
        } else {
          const needsReview = preflightData && Array.isArray(preflightData.needsReview) ? preflightData.needsReview : [];
          if (needsReview.length > 0) {
            pendingRunRef.current = {
              payloadRows,
              site,
              type,
              esgmetric,
              replaceOverlappingPeriods,
              run: executeRunReport,
            };
            setMappingScope({ siteLocation: site, esgMetric: esgmetric });
            setMappingItems(needsReview);
            setShowMappingModal(true);
            setSloading(false);
            return;
          }
        }

        executeRunReport(payloadRows, site, type, esgmetric, replaceOverlappingPeriods);

        setLoading(false);
      };
      reader.readAsBinaryString(file);
    });
  }, [sitelocation]);

  const excel = {
    width: "50px",
  };

  async function uploadFileName(filename, esgMetric) {
    const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetPdfParameterAsync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: filename,
        esgMetric: esgMetric,
        userEmail: username,
      }),
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      if (responseJson.success == false) {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">${responseJson.data}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return { success: false };
      } else {
        const extractedData = responseJson.data?.extractedData ?? responseJson.data;
        function combine(collections) {
          const entries = [...Object.entries(collections)];
          const length = entries[0]?.[1]?.length ?? 0;
          const result = [];
          for (const [name, array] of entries) {
            if (array.length !== length) throw new Error("Non-uniform array lengths");
            for (let i = 0; i < length; i += 1) {
              const item = (result[i] ??= {});
              item[name] = array[i];
            }
          }
          return result;
        }
        const businessUnitValues = Object.values(extractedData);
        const businessUnitKeys = Object.keys(extractedData || {});
        const merged = combine({
          businessunitvalue: businessUnitValues,
          businessunit: businessUnitKeys,
        });
        const dataArray = merged.map((item) => item.businessunit);
        setHeaderFields(dataArray);
        const fmmAc = responseJson.data?.fieldMappingMetadata;
        if (fmmAc) {
          const sm = {};
          Object.entries(fmmAc).forEach(([k, v]) => {
            if (v?.sourceField) sm[k] = v.sourceField;
          });
          setHeaderSourceLabels(sm);
        }
        Swal.fire({
          icon: "success",
          title: filename + " uploaded successfully",
        });
        setImportFile(filename);
        return { success: true, fields: businessUnitKeys };
      }
    } else {
      Swal.fire({
        icon: "error",
        html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">Pdf not uploaded</p>`,
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
      });
      return { success: false };
    }
  }

  /**
   * Extracts error message and suggested metric from PDF response data.
   */
  function extractPdfErrorDetails(data) {
    if (typeof data === "object" && data !== null) {
      return {
        errorMessage: data.ErrorMessage || data.errorMessage || "An error occurred",
        suggestedMetric: data.SuggestedEsgMetric || data.suggestedEsgMetric || "",
      };
    }
    return { errorMessage: data || "An error occurred", suggestedMetric: "" };
  }

  /**
   * Extracts record counts from response data (handles both PascalCase and camelCase).
   */
  function extractRecordCounts(data) {
    if (typeof data !== "object" || data === null) {
      return { totalRecords: 0, successfulRecords: 0, failedRecords: 0 };
    }
    return {
      totalRecords: data.TotalRecords || data.totalRecords || 0,
      successfulRecords: data.SuccessfulRecords || data.successfulRecords || 0,
      failedRecords: data.FailedRecords || data.failedRecords || 0,
    };
  }

  async function runReport(esgM, siteL, connector, fileName = null) {
    setSloading(true);
    try {
      const requestBody = {
        userEmail: username,
        esgMetric: esgM,
        siteLocation: siteL,
        ConnectorName: connector,
        forceRunReport: true,
        ...(fileName && { fileName }),
      };

      const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}run-report-other`, {
        method: "POST",
        headers: { "Content-type": "application/json; charset=UTF-8" },
        body: JSON.stringify(requestBody),
      });

      const responseJson = await res.json();
      setSloading(false);

      // Handle HTTP error or explicit error in response
      if (res.status !== 200 || responseJson.error) {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">Something went wrong while processing this file. Please try again. No data was saved.</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        setDisplayConfirmationModal(false);
        return;
      }

      // Handle success: false response (detailed error from PDF processing)
      if (responseJson.success === false) {
        const { errorMessage, suggestedMetric } = extractPdfErrorDetails(responseJson.data);
        const suggestedHtml = suggestedMetric ? `<p style="font-size: 14px; color: #407775; margin-top: 10px;"><strong>Suggested ESG Metric:</strong> ${suggestedMetric}</p>` : "";
        const bodyHtml = errorMessage.replace(/\s*(No data was saved\.?)\s*$/i, "<br/>$1"); // break the closing line onto its own row

        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">${bodyHtml}</p>${suggestedHtml}`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return;
      }

      // Handle status 400 response
      if (responseJson.status === 400) {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">${responseJson.title}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        return;
      }

      // Response with optional record counts — key off actual saved rows, not just HTTP success
      const { totalRecords, successfulRecords, failedRecords } = extractRecordCounts(responseJson.data);
      const countsHtml = totalRecords > 0 ? `<br/><span style="font-size: 14px;">Total: ${totalRecords} | Success: ${successfulRecords} | Failed: ${failedRecords}</span>` : "";

      if (totalRecords > 0 && successfulRecords === 0) {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4><p style="font-size:16px;">We couldn't save any data from this document. Please check the file and try again.${countsHtml}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      } else if (failedRecords > 0) {
        Swal.fire({
          icon: "warning",
          html: `<h4 style="color: #f8bb86; font-size: 20px; font-weight: bold;">Partial success</h4><p style="font-size:16px;">Some records couldn't be saved.${countsHtml}</p>`,
        });
      } else {
        Swal.fire({
          icon: "success",
          html: `<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Report run successfully${countsHtml}</p>`,
          iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
        });
      }
      setDisplayConfirmationModal(false);
    } catch (err) {
      console.error("Run report error:", err);
      setSloading(false);
      Swal.fire({
        icon: "error",
        html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
        <p style="font-size: 16px;">Something went wrong while processing this file. Please try again. No data was saved.</p>`,
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
      });
      setDisplayConfirmationModal(false);
    }
  }

  /**
   * Handles PDF upload for Run Report - prompts for file, uploads to blob, then runs report.
   */
  const handlePdfUpload = (esgMetric, siteLocation) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".pdf";
    fileInput.style.display = "none";

    fileInput.onchange = async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;

      setSloading(true);

      try {
        // Get SAS token and upload PDF to blob storage
        const sasRes = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, { method: "GET" });
        if (sasRes.status !== 200) {
          throw new Error("Failed to get SAS token");
        }

        const sasJson = await sasRes.json();
        const blobServiceClient = new BlobServiceClient(sasJson.data);
        const containerClient = blobServiceClient.getContainerClient("ecoprismfilecontainer");

        const companyId = localStorage.getItem("company_id") || "default";
        const blobPath = `${companyId}/Configuration/PDF/${file.name}`;
        const blockBlobClient = containerClient.getBlobClient(blobPath).getBlockBlobClient();

        await blockBlobClient.uploadBrowserData(file, {
          blockSize: 4 * 1024 * 1024,
          concurrency: 20,
        });

        // Call runReport with the blob path - backend handles PDF extraction
        await runReport(esgMetric, siteLocation, "PDF", blobPath);
      } catch (error) {
        console.error("PDF upload/run error:", error);
        setSloading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
          <p style="font-size: 16px;">${error.message || "Failed to process PDF"}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    setTimeout(() => document.body.removeChild(fileInput), 100);
  };

  //PDF Code
  async function uploadImage(containerName, file) {
    let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
      method: "GET",
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      const connectionString = responseJson.data;
      const blobServiceClient = new BlobServiceClient(connectionString);
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlobClient(file.name);
      const blockBlobClient = blobClient.getBlockBlobClient();
      const result = await blockBlobClient.uploadBrowserData(file, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
      });
      if (result) {
        const extractResult = await uploadFileName(file.name, esg);

        // Build field mapping suggestions client-side from extracted PDF fields.
        // LLM extracts using exact DTO field names (temperature=0, prompt-enforced),
        // so source keys always match destination keys — no server round-trip needed.
        if (extractResult && extractResult.success && extractResult.fields && extractResult.fields.length > 0) {
          const suggestions = {};
          extractResult.fields.forEach((field) => {
            suggestions[field] = field;
          });
          setSmartMappingSuggestions(suggestions);
        }
      }
    }
  }

  const onDrops = useCallback((acceptedFiles) => {
    const sessionAtDrop = editSessionRef.current;
    const type = localStorage.getItem("type");
    setImportFile(acceptedFiles[0].name);
    const name = acceptedFiles[0].name;
    const extension = name.split(".").pop();
    let sendObj = {
      startDate: "",
      endDate: "",
      energyCons: 0,
    };
    if (type === "Excel") {
      if (extension === "xls" || extension === "xlsx") {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (evt) => {
            if (!isEditModalOpenRef.current || sessionAtDrop !== editSessionRef.current) {
              return;
            }
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary", cellText: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });
            //const workbookHeaders = XLSX.readFile(bstr, { sheetRows: 1 });
            //console.log(data);
            if (data.length === 0) {
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">Excel File is not proper or header is not present</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
              return false;
            }
            setImportFile(acceptedFiles[0].name);
            Swal.fire({
              icon: "success",
              iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
              html: `<h4 style="color: #407775; font-size: 20px;">Success!</h4>
                ${acceptedFiles[0].name} uploaded successfully`,
            });
            const sheet = wb.Sheets[wb.SheetNames[0]];

            const sheetData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });

            if (!sheetData || sheetData.length === 0) {
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">No data found in Excel sheet</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
              setLoading(false);
              return;
            }

            const columnsArray = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
              header: 1,
              defval: "",
              blankrows: false,
            })[0];

            if (!columnsArray) {
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">No header row found in Excel sheet. Please ensure the first row contains column headers.</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
              setLoading(false);
              return;
            }

            if (!Array.isArray(columnsArray) || columnsArray.length === 0) {
              Swal.fire({
                icon: "error",
                html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                <p style="font-size: 16px;">Invalid column structure in Excel sheet</p>`,
                iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
              });
              setLoading(false);
              return;
            }

            // Filter out empty or undefined headers and validate them
            const filteredColumnsArray = columnsArray.filter((header) => {
              if (header === null || header === undefined || header === "") {
                return false;
              }

              const headerStr = header.toString().trim();
              if (headerStr === "") {
                return false;
              }

              // Avoid headers that are just numbers or very short strings
              if (/^\d+$/.test(headerStr) || headerStr.length < 2) {
                return false;
              }

              return true;
            });

            if (filteredColumnsArray.length === 0) {
              // Fallback: try to get headers from the sheet range
              try {
                const sheet = wb.Sheets[wb.SheetNames[0]];
                const range = XLSX.utils.decode_range(sheet["!ref"] || "A1");
                const fallbackHeaders = [];

                // Check for merged cells in the header row
                const mergedCells = sheet["!merges"] || [];
                const headerMerges = mergedCells.filter((merge) => merge.s.r === 0);

                // Get headers from the first row (A1, B1, C1, etc.)
                for (let col = range.s.c; col <= range.e.c; col++) {
                  const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                  const cell = sheet[cellAddress];

                  // Check if this column is part of a merged cell
                  const mergedCell = headerMerges.find((merge) => col >= merge.s.c && col <= merge.e.c);

                  let headerValue;
                  if (mergedCell) {
                    // Use the value from the start of the merged cell
                    const mergedStartAddress = XLSX.utils.encode_cell({ r: 0, c: mergedCell.s.c });
                    const mergedStartCell = sheet[mergedStartAddress];
                    headerValue = mergedStartCell ? mergedStartCell.v : `Column${col + 1}`;
                  } else {
                    headerValue = cell ? cell.v : `Column${col + 1}`;
                  }

                  fallbackHeaders.push(headerValue);
                }

                if (fallbackHeaders.length > 0) {
                  setHeaderFields(fallbackHeaders);
                  var result = fallbackHeaders.join(",");
                } else {
                  throw new Error("Fallback method also failed");
                }
              } catch (fallbackError) {
                Swal.fire({
                  icon: "error",
                  html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;">No valid headers found in Excel sheet.</p>
                  <p style="font-size: 14px; color: #666;">Common causes:</p>
                  <ul style="font-size: 14px; color: #666; text-align: left; margin: 10px 0;">
                    <li>• First row is empty or contains only empty cells</li>
                    <li>• Headers are in a different row (not the first row)</li>
                    <li>• Excel file has merged cells in the header row</li>
                    <li>• File format issues or corruption</li>
                  </ul>
                  <p style="font-size: 14px; color: #666;">Please ensure the first row contains valid column headers.</p>`,
                  iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
                  width: "500px",
                });
                setLoading(false);
                return;
              }
            } else {
              setHeaderFields(filteredColumnsArray);
            }
            /* Update state */
            const jsonData = JSON.parse(JSON.stringify(data));
            const newdata = [];
            _.forEach(jsonData, (jd) => {
              sendObj.energyCons = jd.EnergyConsumption;
              sendObj.startDate = jd.StartDate;
              sendObj.endDate = jd.EndDate;
              newdata.push({
                email: "sudies@ecoprism.com",
                energy: sendObj.energyCons,
                region: "DK",
                reportPeriod: 2,
                endTimeEpoch: sendObj.endDate,
                unit: "kWh",
              });
              //console.log(jd, 'hsdajshd')
            });
            setLoading(false);
          };
          reader.readAsBinaryString(file);
        });
      } else {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Invalid File Format</h4>
          <p style="font-size: 16px;">The uploaded file is not an Excel file. Please upload a valid Excel file (.xlsx or .xls).</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        setImportFile();
        return false;
      }
    }
    if (type === "PDF") {
      if (extension === "pdf") {
        uploadImage("ecoprismfilecontainer", acceptedFiles[0]);
      } else {
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Invalid File Format</h4>
          <p style="font-size: 16px;">The uploaded file is not a PDF file. Please upload a valid PDF file (.pdf).</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
        setImportFile();
        return false;
      }
    }
  }, []);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [activeTable, setActiveTable] = useState(true);
  const [inactiveTable, setInActiveTable] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [activePage, setActivePage] = useState(0);
  const [inactivePage, setInactivePage] = useState(0);
  const [activeRowsPerPage, setActiveRowsPerPage] = useState(10);
  const [inactiveRowsPerPage, setInactiveRowsPerPage] = useState(10);
  // Active Table Page Change Handler
  const handleActivePageChange = (event, newPage) => {
    setActivePage(newPage);
  };

  // Inactive Table Page Change Handler
  const handleInactivePageChange = (event, newPage) => {
    setInactivePage(newPage);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page

  useLayoutEffect(() => {
    initializeDataTable();
    initializeDataTable1();
    setActive("block");
    setInactive("none");
    setInact("inactive-buttonred");
    setAct("active-buttongreen");
  }, [activeconfig]);

  const initializeDataTable = () => {
    if (!$.fn.DataTable.isDataTable("#myTable")) {
      $("#myTable").DataTable({
        orderCellsTop: true,
        fixedHeader: false,
        initComplete: function () {
          var api = this.api();
          var originalData = api.rows().data().toArray();

          // Handle global search
          $("#globalSearch").on("keyup change", function () {
            var enteredValue = $(this).val().toLowerCase();

            // Filter the data manually
            var filteredData = originalData.filter(function (value) {
              return Object.values(value).some(function (columnValue) {
                var columnString = columnValue.toString().toLowerCase();
                return columnString.includes(enteredValue) || columnString.replace(/,/g, "").includes(enteredValue);
              });
            });

            // Clear the table and redraw with filtered data
            api.clear().rows.add(filteredData).draw();
          });

          api
            .columns()
            .eq(0)
            .each(function (colIdx) {
              var cell = $(".filters th").eq($(api.column(colIdx).header()).index());
              var title = $(cell).text();
              $(cell).html('<input type="text" class="search-input" placeholder="' + title + '" />');
              $("input", $(".filters th").eq($(api.column(colIdx).header()).index()))
                .off("keyup change")
                .on("keyup change", function (e) {
                  e.stopPropagation();
                  $(this).attr("title", $(this).val());

                  // Remove commas from the entered value
                  var enteredValue = this.value.replace(/,/g, "").toLowerCase();

                  // Filter the data manually
                  var filteredData = originalData.filter(function (value) {
                    var columnString = value[colIdx].toString().toLowerCase();
                    return columnString.includes(enteredValue) || columnString.replace(/,/g, "").includes(enteredValue);
                  });

                  // Clear the table and redraw with filtered data
                  api.clear().rows.add(filteredData).draw();
                });
            });
        },
      });
    }
  };

  const initializeDataTable1 = () => {
    if (!$.fn.DataTable.isDataTable("#myTable1")) {
      $("#myTable1").DataTable({
        orderCellsTop: true,
        fixedHeader: false,
        initComplete: function () {
          var api = this.api();
          var originalData = api.rows().data().toArray();

          $("#customSearchDivinactive").append('<input type="text" id="globalSearch1" class="search-input search-container " placeholder="Search all data" />');

          // Handle global search
          $("#globalSearch1").on("keyup change", function () {
            var enteredValue = $(this).val().toLowerCase();

            // Filter the data manually
            var filteredData = originalData.filter(function (value) {
              return Object.values(value).some(function (columnValue) {
                var columnString = columnValue.toString().toLowerCase();
                return columnString.includes(enteredValue) || columnString.replace(/,/g, "").includes(enteredValue);
              });
            });

            // Clear the table and redraw with filtered data
            api.clear().rows.add(filteredData).draw();
          });

          api
            .columns()
            .eq(0)
            .each(function (colIdx) {
              var cell = $(".filters1 th").eq($(api.column(colIdx).header()).index());
              var title = $(cell).text();
              $(cell).html('<input type="text" class="search-input" placeholder="' + title + '" />');
              $("input", $(".filters1 th").eq($(api.column(colIdx).header()).index()))
                .off("keyup change")
                .on("keyup change", function (e) {
                  e.stopPropagation();
                  $(this).attr("title", $(this).val());

                  // Remove commas from the entered value
                  var enteredValue = this.value.replace(/,/g, "").toLowerCase();

                  // Filter the data manually
                  var filteredData = originalData.filter(function (value) {
                    var columnString = value[colIdx].toString().replace(/,/g, "").toLowerCase();
                    return columnString.includes(enteredValue);
                  });

                  // Clear the table and redraw with filtered data
                  api.clear().rows.add(filteredData).draw();
                });
            });
        },
      });
    }
  };

  const toggleTable = (name) => {
    // Initialize DataTable instance for the selected tab
    if (name === "active") {
      setActive("block");
      setInactive("none");
      setInact("inactive-buttonred");
      setAct("active-buttongreen");
    } else if (name === "inactive") {
      setInact("active-buttonred");
      setAct("inactive-buttongreen");
      setActive("none");
      setInactive("block");
    }
    setPage(0); // Reset page when switching tables
  };

  /**
   * Renders the run action cell based on connector type.
   */
  function renderRunAction(row) {
    if (isExcelConnector(row.fileFormat)) {
      return (
        <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles, row.siteLocationId, row.fileFormat, row.esgMetric, row.reportFrequency)}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="allconfig-run-upload" title="Upload Excel and run report">
              <input {...getInputProps()} />
              <img src="assets/img/import.png" alt="" />
            </div>
          )}
        </Dropzone>
      );
    }

    if (isPdfConnector(row.fileFormat)) {
      return (
        <button className="icon-action-button" onClick={() => handlePdfUpload(row.esgMetric, row.siteLocationId)} title="Upload PDF and Run Report">
          <img className="icon" src="assets/img/import.png" alt="" />
        </button>
      );
    }

    if (isApiConnector(row.fileFormat)) {
      return (
        <button className="icon-action-button" onClick={() => runReport(row.esgMetric, row.siteLocationId, row.fileFormat)} title="Run API connector">
          <img src="assets/img/link-icon.svg" alt="Run" style={{ width: "20px", height: "20px" }} />
        </button>
      );
    }

    return (
      <button className="icon-action-button" onClick={() => runReport(row.esgMetric, row.siteLocationId, row.fileFormat)}>
        <img className="run-icon" src="assets/img/import.png" alt="" />
      </button>
    );
  }

  const data =
    activeconfig &&
    activeconfig.map((row) => [
      <div className="actions">
        <div className="mr-20">
          <EditIcon style={{ cursor: "pointer", color: "#407775", width: "20px", height: "20px" }} onClick={() => showEditModal(row.module, row.esgMetric, row.siteLocationId, row.fileFormat)} />
          <img className="action-icon" src="assets/img/deactivate.png" alt="Deactivate" style={{ cursor: "pointer", color: "#407775" }} onClick={() => showDeleteModal(row.siteLocationId, row.fileFormat, row.esgMetric)} />
        </div>
        {" " + row.siteLocationId}
      </div>,
      row.esgMetric,
      row.reportFrequency,
      getConnectorIcon(row.fileFormat),
      new Date(row.updatedAt).toLocaleString("en-GB"),
      renderRunAction(row),
      <a href={`/reporthistory?sl=${row.siteLocationId}&esg=${row.esgMetric}`}>
        <RemoveRedEyeIcon className="run-icon" style={{ cursor: "pointer", color: "#407775" }} />
      </a>,
    ]);

  const ddata =
    deactiveconfig &&
    deactiveconfig.map((row) => [
      <div className="actions">
        <div className="mr-20">
          <img className="action-icon" src="assets/img/deactivate.png" alt="Deactivate" style={{ cursor: "pointer", color: "#407775" }} onClick={() => reactive(row.siteLocationId, row.esgMetric, row.fileFormat)} />
        </div>
        {" " + row.siteLocationId}
      </div>,
      row.esgMetric,
      row.reportFrequency,
      getConnectorIcon(row.fileFormat),
      new Date(row.updatedAt).toLocaleString("en-GB"),
      isExcelConnector(row.fileFormat) ? (
        <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles, row.siteLocationId, row.fileFormat, row.esgMetric, row.reportFrequency)}>
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="allconfig-run-upload" title="Upload Excel and run report">
              <input {...getInputProps()} />
              <img src="assets/img/import.png" alt="" />
            </div>
          )}
        </Dropzone>
      ) : (
        <button className="ml-15 icon-action-button" onClick={() => runReport(row.esgMetric, row.siteLocationId, row.fileFormat)}>
          <img className="run-icon" src="assets/img/import.png" alt="" />
        </button>
      ),
      <a href={`/reporthistory?sl=${row.siteLocationId}&esg=${row.esgMetric}`}>
        <RemoveRedEyeIcon className="run-icon" style={{ cursor: "pointer", color: "#407775" }} />
      </a>,
    ]);

  const [globalFilter, setGlobalFilter] = useState("");
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };

  const dropzoneLabelStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "170px",
    border: "1px dashed #b7c4d3",
    borderRadius: "10px",
    padding: "32px 24px",
    textAlign: "center",
    background: "#f8fbff",
    color: "#407775",
    boxSizing: "border-box",
  };

  const dropzoneTextStyle = {
    maxWidth: "280px",
    marginTop: "8px",
    fontSize: "15px",
    color: "#407775",
    wordBreak: "break-word",
  };

  const cancelButtonStyles = {
    color: "#000",
    width: "120px",
    height: "41px",
    borderRadius: "10px",
    marginLeft: "auto",
  };

  const nextButtonsStyle = {
    marginTop: "30px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: "flex-start",
  };

  const dropzoneSectionStyle = {
    marginBottom: "32px",
  };

  return (
    <div id="wrapper">
      <div>
        {sloading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div>
        <Toaster position="top-right" reverseOrder={false} />
      </div>
      {renderHeader2()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div class="container formpd">
          <div class="flex">
            <div class="col-md-9 pd-0">
              <div Class="steps__containt-hader">
                <h3 class="title">All Configurations</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="">
                      Configuration
                    </Link>
                    <Typography color="text.primary">All Configurations</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div class="col-md-3 pd-0">
              <div Class="steps__containt-hader btalignleft">
                <Link to="/configuration" className="add-cta">
                  + Setup New Configuration
                </Link>
                {/* <a href="/configuration" className="add-cta">
                  + Setup New Configuration
                </a> */}
              </div>
            </div>
          </div>
          <div class="col-md-12 flex pd-0"></div>

          {/* <div class="col-md-9 pd-0 mb-10">
          <button id="active" className={act} onClick={() => toggleTable('active')}><span className="record-count">{activeCounter}</span><span>Active</span></button>
          <button id="inactive" className={inact} onClick={() => toggleTable('inactive')}><span className="record-count">{inactiveCounter}</span> <span>Inactive </span> </button>
        </div> */}
          <div className="row" style={{ display: active }}>
            <DataTable
              value={activeconfig}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              dataKey="id"
              filters={filters}
              filterDisplay="row"
              globalFilterFields={["siteLocationId", "esgMetric", "reportFrequency", "fileFormat", "updatedAt"]}
              header={header}
              emptyMessage="No data found."
            >
              <Column
                header=""
                body={(rowData) => (
                  <div>
                    <EditIcon title="Edit" style={{ cursor: "pointer", color: "#407775", width: "20px", height: "20px" }} onClick={() => showEditModal(rowData.module, rowData.esgMetric, rowData.siteLocationId, rowData.fileFormat)} />

                    <img className="action-icon" src="assets/img/deactivate.png" alt="Deactive" style={{ cursor: "pointer", color: "#407775" }} onClick={() => showDeleteModal(rowData.siteLocationId, rowData.fileFormat, rowData.esgMetric)} />
                  </div>
                )}
                style={{ minWidth: "6rem", paddingLeft: "30px" }}
              />
              <Column sortable field="siteLocationId" header="Site Location" filter filterPlaceholder="Filter" style={{ minWidth: "11rem" }} />
              <Column sortable header="ESG parameter" field="esgMetric" style={{ minWidth: "14rem" }} filter filterPlaceholder="Filter" />
              <Column header="Anomaly Status" align="center" alignHeader="center" body={(rowData) => <ElectricityAnomalyStatus facility={rowData.siteLocationId} esgMetric={rowData.esgMetric} />} style={{ minWidth: "10rem" }} bodyStyle={{ whiteSpace: "nowrap" }} />
              <Column header="Data connector" align="center" alignHeader="center" body={(rowData) => <div>{getConnectorIcon(rowData.fileFormat, 30)}</div>} style={{ minWidth: "8rem" }} />
              <Column
                header="Run"
                align="center"
                alignHeader="center"
                body={(rowData) => <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>{renderRunAction(rowData)}</div>}
                style={{ minWidth: "7rem" }}
              />
              <Column
                header="Report history"
                align="center"
                alignHeader="center"
                body={(rowData) => (
                  <div>
                    <a href={`/reporthistory?sl=${rowData.siteLocationId}&esg=${rowData.esgMetric}`}>
                      <RemoveRedEyeIcon className="run-icon" style={{ cursor: "pointer", color: "#407775" }} />
                    </a>
                  </div>
                )}
                style={{ minWidth: "9rem" }}
              />
              <Column sortable header="Data frequency" field="reportFrequency" style={{ minWidth: "11rem" }} filter filterPlaceholder="Filter" />
              <Column sortable header="Last Refresh" field="updatedAt" body={(rowData) => <div>{new Date(rowData.updatedAt).toLocaleString("en-GB")}</div>} style={{ minWidth: "13rem", paddingRight: "30px" }} filter filterPlaceholder="Filter" />
            </DataTable>
          </div>
          <div className="row" style={{ display: inactive }}>
            <DataTable
              value={deactiveconfig}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              dataKey="id"
              filters={filters1}
              filterDisplay="row"
              globalFilterFields={["siteLocationId", "esgMetric", "reportFrequency", "fileFormat", "updatedAt"]}
              header={header1}
              emptyMessage="No data found."
            >
              <Column
                header=""
                body={(rowData) => (
                  <div>
                    <img className="action-icon" src="assets/img/reactivate.png" alt="Reactive" style={{ cursor: "pointer", color: "#407775" }} onClick={() => reactive(rowData.siteLocationId, rowData.esgMetric, rowData.fileFormat)} />
                  </div>
                )}
                style={{ minWidth: "6rem", paddingLeft: "30px" }}
              />
              <Column sortable field="siteLocationId" header="Site Location" filter filterPlaceholder="Filter" style={{ minWidth: "11rem" }} />
              <Column sortable header="ESG parameter" field="esgMetric" style={{ minWidth: "14rem" }} filter filterPlaceholder="Filter" />
              <Column header="Data connector" align="center" alignHeader="center" body={(rowData) => <div>{getConnectorIcon(rowData.fileFormat, 30)}</div>} style={{ minWidth: "8rem" }} />

              <Column
                header={<div style={{ textAlign: "center", width: "100%" }}>Run</div>}
                body={(rowData) => (
                  <div>
                    <img className="run-icon" src="assets/img/import.png" alt="" />
                    {/* {rowData.fileFormat === "Excel" ? (
                      <Dropzone
                        onDrop={(acceptedFiles) =>
                          onDrop(
                            acceptedFiles,
                            rowData.siteLocationId,
                            rowData.fileFormat,
                            rowData.esgMetric
                          )
                        }
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone__section">
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div className="dropzone1">
                                <label for="files" class="dropzone-container1">
                                  <img className="run-icon" src="assets/img/import.png" alt="" />
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    ) : (
                      <button
                        className="ml-15"
                        onClick={() =>
                          runReport(rowData.esgMetric, rowData.siteLocationId, rowData.fileFormat)
                        }
                      >
                        <img className="run-icon" src="assets/img/import.png" alt="" />
                      </button>
                    )} */}
                  </div>
                )}
                style={{
                  minWidth: "7rem",
                  display: "inline-flex",
                  justifyContent: "center",
                  paddingTop: "10px",
                }}
              />

              <Column
                header="Report history"
                align="center"
                alignHeader="center"
                body={(rowData) => (
                  <div>
                    <a href={`/reporthistory?sl=${rowData.siteLocationId}&esg=${rowData.esgMetric}`}>
                      <RemoveRedEyeIcon className="run-icon" style={{ cursor: "pointer", color: "#407775" }} />
                    </a>
                  </div>
                )}
                style={{ minWidth: "9rem" }}
              />
              <Column sortable header="Data frequency" field="reportFrequency" style={{ minWidth: "11rem" }} filter filterPlaceholder="Filter" />
              <Column sortable header="Last Refresh" field="updatedAt" body={(rowData) => <div>{new Date(rowData.updatedAt).toLocaleString("en-GB")}</div>} style={{ minWidth: "13rem", paddingRight: "30px" }} filter filterPlaceholder="Filter" />
            </DataTable>
          </div>

          <DeleteConfirmation confirmModal={submitDelete} showModal={displayConfirmationModal} hideModal={hideConfirmationModal} message={deleteMessage} deletename={deletename} />

          <ReviewGateModal
            show={showReviewModal}
            rows={reviewRows}
            userEmail={username}
            variant={isWasteMetric(reviewMetric) ? "waste" : "pgs"}
            confirmEndpoint={isWasteMetric(reviewMetric) ? "ConfirmWasteMapping" : "ConfirmActivityMapping"}
            onClose={() => setShowReviewModal(false)}
            onAllResolved={() => {
              setShowReviewModal(false);
              fetchConnectorConfig();
            }}
          />

          <MappingGateModal
            show={showMappingModal}
            items={mappingItems}
            userEmail={username}
            siteLocation={mappingScope.siteLocation}
            esgMetric={mappingScope.esgMetric}
            onCancel={() => {
              setShowMappingModal(false);
              pendingRunRef.current = null;
              setSloading(false);
            }}
            onSaved={() => {
              setShowMappingModal(false);
              const pending = pendingRunRef.current;
              pendingRunRef.current = null;
              if (pending && typeof pending.run === "function") {
                setSloading(true);
                pending.run(pending.payloadRows, pending.site, pending.type, pending.esgmetric, pending.replaceOverlappingPeriods);
              }
            }}
          />

          <Modal show={editIsOpen} onHide={hideEditModal} className="custom-modal-width-config">
            <Modal.Header closeButton style={{ paddingTop: "15px", paddingBottom: "15px" }}>
              <div Class="steps__containt-hader" style={{ paddingLeft: "45px" }}>
                <h3 class="title">Edit Connector Config</h3>
              </div>
            </Modal.Header>
            <Modal.Body>
              <form>
                <div className="steps__containt-body">
                  {loading && <div class="loading">Loading&#8230;</div>}
                  <div className="steps__containt-left">
                    <Stepper
                      activeStep={activeStep}
                      orientation="vertical"
                      className="allconfig-edit-modal-stepper"
                      sx={{
                        color: "#37517e",
                        "& .MuiSlider-thumb": {
                          borderRadius: "1px",
                        },
                        padding: "22px 0 24px 0",
                        margin: 0,
                      }}
                    >
                      {steps.map((step, index) => (
                        <Step key={step.label}>
                          <StepLabel
                            sx={{
                              "& .MuiStepLabel-root .Mui-completed": {
                                color: "secondary.dark", // circle color (COMPLETED)
                              },
                              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
                                color: "grey.500", // Just text label (COMPLETED)
                              },
                              "& .MuiStepLabel-root .Mui-active": {
                                color: "secondary.main", // circle color (ACTIVE)
                              },
                              "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
                                color: "common.white", // Just text label (ACTIVE)
                              },
                              "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                                fill: "black", // circle's number (ACTIVE)
                              },
                            }}
                          >
                            {step.label}
                          </StepLabel>
                          <StepContent>
                            <Typography>{step.description}</Typography>
                            <Box sx={{ mb: 2 }}>
                              <div></div>
                            </Box>
                          </StepContent>
                        </Step>
                      ))}
                    </Stepper>
                  </div>
                  <div className="steps__containt-right">
                    {activeStep === 0 && (
                      <div>
                        <div className="steps__containt-hader">
                          <h3 className="title">Select data type</h3>
                          <p>Select the data parameter to set up the new connection.</p>
                        </div>
                        <hr className="hr-style" />
                        <div className="steps__container">
                          <form>
                            <div className="row">
                              <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                <div className="mb-3">
                                  <label className="formlable">Select ESG parameter</label>
                                  <input type="text" readOnly value={module} class="form-control" />
                                </div>
                                <div className="mb-3">
                                  <label className="formlable">Site location</label>
                                  <input type="text" readOnly value={site} class="form-control" />
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}

                    {activeStep === 1 && (
                      <div>
                        <div className="steps__containt-hader">
                          <h3 className="title">Choose data connector</h3>
                          <p>Simplify data collection using import options such as excel sheets, XML files and API integration.</p>
                        </div>
                        <hr />
                        <div className="steps__container">
                          <div>
                            <label className="form-label">Choose connector</label>
                            <div className="mb-3">
                              <label className="formlable">File Format</label>
                              <input type="text" readOnly value={file} class="form-control" />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeStep === 2 && (
                      <div>
                        <div className="steps__containt-hader">
                          <h3 className="title">Create connection</h3>
                          <p>{isPdfConnector(selectedExcel) ? "Configure the PDF connector for the selected ESG parameter" : "Upload the excel sheet with the data for the selected ESG parameter"}</p>
                        </div>
                        <hr />
                        <div className="steps__container">
                          {isPdfConnector(selectedExcel) ? (
                            <div style={{ padding: "20px", textAlign: "center" }}>
                              <img src="assets/img/pdf.png" alt="PDF" style={{ width: "60px", marginBottom: "15px" }} />
                              <h5 style={{ color: "#407775", marginBottom: "10px" }}>PDF Connector Configuration</h5>
                              <p style={{ color: "#666", marginBottom: "10px" }}>PDF files will be uploaded when running the report.</p>
                              <p style={{ color: "#407775", fontStyle: "italic" }}>Field mapping is handled automatically using AI extraction.</p>
                            </div>
                          ) : (
                            <>
                              <div className="mt-3" style={{ color: "#407775" }}>
                                {importfile ? <p>{importfile} Uploaded successfully</p> : null}
                              </div>
                              <Dropzone onDrop={(acceptedFiles) => onDrops(acceptedFiles)}>
                                {({ getRootProps, getInputProps }) => (
                                  <div className="dropzone__section" style={dropzoneSectionStyle}>
                                    <div {...getRootProps()}>
                                      <input {...getInputProps()} />
                                      <div className="dropzone">
                                        <label htmlFor="files" className="dropzone-container" style={dropzoneLabelStyle}>
                                          <div className="file-icon">
                                            <img src="assets/img/import.png" alt="upload" style={{ width: "30px", height: "30px" }} />
                                          </div>
                                          <div className="dropzone-title" style={dropzoneTextStyle}>
                                            <span className="browse">Browse</span> or drag and drop
                                          </div>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Dropzone>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {activeStep === 3 && (
                      <div className="table__section">
                        <div className="data__table">
                          <div className="steps__containt-hader">
                            <h3 className="title">Map the fields</h3>
                            <p>Map the fields from the data source to the attributes of the standard Ecoprism data requirement.</p>
                          </div>
                          <hr />
                          <div className="steps__container">
                            <div className="table-responsive">
                              <table className="table custom-table ">
                                <thead>
                                  <tr>
                                    <th scope="col">Data field</th>
                                    <th scope="col">Field in Data source</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.keys(excelfields).map((keyName, i) => (
                                    <tr key={keyName}>
                                      <td>
                                        <div class="form-group col-md-12">
                                          {(() => {
                                            const currentValue = excelMappingByDest[keyName] ?? "None";
                                            const sourceHeaders = filterExcelHeaders(headerfields);
                                            const options = [
                                              { value: "None", label: "None", disabled: false },
                                              ...sourceHeaders.map((header) => ({
                                                value: header,
                                                label: disambiguateSourceLabel(header, headerSourceLabels, sourceHeaders),
                                                disabled: isHeaderMappedElsewhere(header, keyName),
                                              })),
                                            ];
                                            return <Dropdown inputId={"excelSelect" + i} className="form-control wd-100" value={currentValue} onChange={(e) => excelH(e.value ?? "None", keyName)} options={options} placeholder="None" appendTo={document.body} scrollHeight="240px" panelClassName="form-dropdown-panel" itemTemplate={dropdownItemTemplate} aria-label={formatRequirementFieldName(keyName)} />;
                                          })()}
                                          <input type="hidden" id={"excel" + i} value={excelMappingByDest[keyName] ?? "None"} name="excelHeaders[]" readOnly />
                                        </div>
                                      </td>
                                      <td>
                                        {formatRequirementFieldName(keyName)} <span style={{ color: "red" }}>{excelfields[keyName] === true ? "*" : ""}</span>
                                        <input type="hidden" value={keyName} name="destination[]" />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          {/* <h5>Result</h5>
                              <p>co2e : {result.co2e} {result.co2eUnit}</p>
                              <p> co2e Calculation Method : {result.co2eCalculationMethod}</p> */}
                        </div>
                      </div>
                    )}
                    {activeStep === 4 && (
                      <div>
                        <div className="steps__containt-hader">
                          <h3 className="title">Review data connection</h3>
                          <p>Review your data connection ensuring seamless integration and optimal performance</p>
                        </div>
                        <hr />
                        <div className="steps__container">
                          <div className="col-md-3"></div>
                          <div className="finish">
                            <p>
                              <strong>ESG parameter</strong> : {mymodule}
                            </p>
                            <p>
                              <strong>Site</strong> : {sitelocation1}
                            </p>
                            <p>
                              <strong>Data connector</strong> : {selectedExcel}
                            </p>
                            <p>
                              <strong>Owner</strong> : {username}
                            </p>
                            {isPdfConnector(selectedExcel) && <p style={{ color: "#407775", fontStyle: "italic", marginTop: "10px" }}>Field mapping is handled automatically for PDF files using AI extraction.</p>}
                          </div>
                          <div className="col-md-3"></div>
                        </div>
                      </div>
                    )}
                    {activeStep === 5 && (
                      <div>
                        <div className="steps__containt-hader">
                          <h3 className="title">Data connection</h3>
                          <p>The connection has been established and is now accessible in the configuration list</p>
                        </div>
                        <hr />
                        <div className="steps__container">
                          <div class="col-md-3"></div>
                          <div class="finish1">
                            <p>Connection created successfully</p>
                          </div>
                          <div class="col-md-3"></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer style={{ display: "flex", padding: "20px 15px 20px 65px" }}>
              {activeStep === 0 && (
                <Button
                  style={{ marginLeft: "30px!important" }}
                  onClick={handleNext}
                  className="next-button"
                  variant="contained"
                  size="medium"
                  sx={{
                    color: "#fff",
                    backgroundColor: "#407775",
                    width: "120px",
                    height: "41px",
                    borderRadius: "10px",
                  }}
                >
                  Next
                </Button>
              )}
              {activeStep === 1 && (
                <>
                  <Button
                    onClick={handleBack}
                    variant="outlined"
                    size="medium"
                    className="outline-btn"
                    sx={{
                      color: "#000",
                      marginLeft: "10px",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    onClick={handleNext}
                    className="next-button"
                    variant="contained"
                    size="medium"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#407775",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                  >
                    Next
                  </Button>
                  <Button variant="outlined" size="medium" className="outline-btn" onClick={hideEditModal} sx={{ ...cancelButtonStyles, marginLeft: "10px" }}>
                    Cancel
                  </Button>
                </>
              )}
              {activeStep === 2 && (
                <>
                  <Button
                    onClick={handleBack}
                    variant="outlined"
                    size="medium"
                    className="outline-btn"
                    sx={{
                      color: "#000",
                      marginLeft: "10px",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    onClick={handleNext}
                    className="next-button"
                    variant="contained"
                    size="medium"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#407775",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                    disabled={!importfile && !isPdfConnector(selectedExcel)}
                  >
                    Next
                  </Button>
                  <Button variant="outlined" size="medium" className="outline-btn" onClick={hideEditModal} sx={{ ...cancelButtonStyles, marginLeft: "10px" }}>
                    Cancel
                  </Button>
                </>
              )}
              {activeStep === 3 && (
                <>
                  <Button
                    onClick={handleBack}
                    variant="outlined"
                    size="medium"
                    className="outline-btn"
                    sx={{
                      color: "#000",
                      marginLeft: "10px",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    onClick={handleNext}
                    className="next-button"
                    variant="contained"
                    size="medium"
                    disabled={!mandatoryExcelMappingsComplete(excelfields, excelMappingByDest)}
                    sx={{
                      color: "#fff",
                      backgroundColor: "#407775",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                      marginLeft: "10px",
                      "&.Mui-disabled": {
                        backgroundColor: "#c5c5c5",
                        color: "#fff",
                      },
                    }}
                  >
                    Next
                  </Button>
                  <Button variant="outlined" size="medium" className="outline-btn" onClick={hideEditModal} sx={{ ...cancelButtonStyles, marginLeft: "10px" }}>
                    Cancel
                  </Button>
                </>
              )}
              {activeStep === 4 && (
                <>
                  <Button
                    onClick={handleBack}
                    variant="outlined"
                    size="medium"
                    className="outline-btn"
                    sx={{
                      color: "#000",
                      marginLeft: "10px",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    size="medium"
                    sx={{
                      color: "#fff",
                      backgroundColor: "#407775",
                      width: "120px",
                      height: "41px",
                      borderRadius: "10px",
                      marginLeft: "10px",
                      "&:hover": {
                        backgroundColor: "#2d5456",
                      },
                    }}
                  >
                    Save
                  </Button>
                  <Button variant="outlined" size="medium" className="outline-btn" onClick={hideEditModal} sx={{ ...cancelButtonStyles, marginLeft: "10px" }}>
                    Cancel
                  </Button>
                </>
              )}
              {activeStep === 5 && (
                <Button
                  sx={{
                    color: "#fff",
                    backgroundColor: "#407775",
                    width: "120px",
                    height: "41px",
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: "#2d5456",
                    },
                  }}
                  onClick={handleReset}
                >
                  <Link to="/allconfigrations" className="btn btn-primary" style={{ textDecoration: "none", color: "inherit" }}>
                    All configurations
                  </Link>
                </Button>
              )}
            </Modal.Footer>
          </Modal>

          <div class="container">{message}</div>
        </div>
      </div>
    </div>
  );
}
